import { Skeleton as AntdSkeleton } from "antd"
import PropTypes from "prop-types"
import styles from "./index.module.less"

function SkeletonBody({
  type,
  size,
  active = true,
  enableAvatar,
  avatarShape,
  width,
  height,
  titleWidth = "100%",
  titleHeight,
  ...rest
}) {
  switch (type) {
    case "title":
      return <AntdSkeleton.Input active={active} size={size} {...rest} />
    case "antTitle":
      return (
        <div className={styles.inputSkeleton} style={{ width: titleWidth, "--ant-control-height": titleHeight }}>
          <AntdSkeleton.Input active={active} {...rest} />
        </div>
      )
    case "paragraph":
      return (
        <AntdSkeleton.Input
          active={active}
          size={size}
          block={true}
          style={{ width: "100%", height: height, lineHeight: height }}
          {...rest}
        />
      )
    case "antparagraph":
      return <AntdSkeleton active={active} {...rest} />
    case "input":
      return (
        <AntdSkeleton.Input
          active={active}
          size={size}
          block={true}
          style={{
            width: width ?? "100%",
            height: height ?? 48,
            lineHeight: height ?? 48,
          }}
          {...rest}
        />
      )
    case "button":
      return (
        <AntdSkeleton.Button
          active={active}
          size={size}
          style={{ maxWidth: width, width, height: height, lineHeight: height }}
          width={width}
          height={height}
          {...rest}
        />
      )
    case "radioButton":
      return (
        <AntdSkeleton.Button
          active={active}
          size={size}
          style={{ maxWidth: width, width, height: height, lineHeight: height, borderRadius: 30 }}
          width={width}
          height={height}
          {...rest}
        />
      )
    case "avatar":
      return (
        <AntdSkeleton.Avatar
          active={active}
          size={size}
          avatarShape={avatarShape}
          width={width}
          height={height}
          {...rest}
        />
      )
    case "image":
      return <AntdSkeleton.Image active={active} size={size} avatarShape={avatarShape} {...rest} />
    case "label":
      return <AntdSkeleton.Button active size="small" style={{ height: 22 }} />
    default:
      return <AntdSkeleton block={true} active={active} {...rest} />
  }
}

SkeletonBody.propTypes = {
  type: PropTypes.oneOf(["title", "paragraph", "input", "button", "avatar", "image", undefined]),
  size: PropTypes.string,
  active: PropTypes.bool,
  enableAvatar: PropTypes.bool,
  avatarShape: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.number,
}

SkeletonBody.defaultProps = {
  type: "button",
  size: "default",
  // active: true,
  enableAvatar: true,
  avatarShape: "circle",
  width: 50,
  height: 32,
}

export default SkeletonBody
